import React from 'react';
import { CreditCard, Security } from '@mui/icons-material';
import InfoCards from '@/components/common/InfoCards';


const InfoPurchaseSection: React.FC = () => {
    return (
        <InfoCards
            layout="stacked"
            stackSpacing={{ xs: 3, md: 4 }}
            containerMargin={{ xs: 6, md: 6, lg: 6 }}
            cards={[
                {
                    icon: <CreditCard />,
                    iconColor: 'secondary.main',
                    title: 'Realizar Pagos con Múltiples Métodos',
                    content: 'Tarjetas de crédito (Visa, Mastercard, American Express, Dinners), Tarjetas débito, PSE, Débito directo desde tu banco, Efectivo en Efecty, Baloto, Puntofred, Su Suerte, Corresponsales bancarios',
                    useIconBox: true
                },
                {
                    icon: <Security />,
                    iconColor: 'primary.main',
                    title: 'Seguridad Garantizada',
                    content: (
                        <>
                            Todas las transacciones están protegidas con:
                            <br />• Encriptación SSL
                            <br />• Certificación PCI DSS
                            <br />• Validación 3D Secure para tarjetas
                            <br />• Sistema antifraude
                        </>
                    ),
                    useIconBox: true
                }
            ]}
        />
    );
};

export default InfoPurchaseSection;